import { Package } from 'utils/api/models/numbers/usage';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import { translate } from 'components/Translation';
import moment from 'moment';

export const jawazakPackageName = (singlePackage: Package): string => {
	const type = singlePackage.commerceAttributes?.roamingType === 'JAWAZAK WORLD' ? 'world' : 'gcc';
	const duration = singlePackage.commerceAttributes?.duration;
	const packageSize = singlePackage.packageSize;

	return duration > 1
		? translate(`number.services.jawazak.${type}.package.name.days`, packageSize.value, packageSize.unit, duration)
		: translate(`number.services.jawazak.${type}.package.name`, packageSize.value, packageSize.unit);
};

export const jawazakActivationPackageName = (singlePackage: types.ecommerce.CatalogEntryView): string => {
	const attributes = singlePackage.attributes;
	const type =
		extractAttributeValue({ attributes }, CustomAttribute.ROAMING_TYPE) === 'JAWAZAK WORLD' ? 'world' : 'gcc';
	const duration = extractAttributeValue({ attributes }, CustomAttribute.DURATION);
	const packageSize = extractAttributeValue({ attributes }, CustomAttribute.INCLUDED_ROAMING_DATA);

	return duration > 1
		? translate(`number.services.jawazak.${type}.active.package.name.days`, packageSize, duration)
		: translate(`number.services.jawazak.${type}.active.package.name`, packageSize);
};

export const jawazakPackageDescription = (singlePackage: Package): string => {
	const packageSize = singlePackage.packageSize;
	const totalPackageSize = singlePackage.totalPackageSize;
	const packageSizeUnit = packageSize.unit === 'GB' ? 1024 : 1;
	const totalPackageSizeUnit = totalPackageSize.unit === 'GB' ? 1024 : 1;
	const numberOfPackages = Math.round(
		((totalPackageSize.value / packageSize.value) * totalPackageSizeUnit) / packageSizeUnit
	);
	const validTo = moment(singlePackage.validTo).format('DD.MM.YYYY, HH:mm A');
	return numberOfPackages > 1
		? translate(
				'number.services.jawazak.packages.description',
				numberOfPackages,
				totalPackageSize.value,
				totalPackageSize.unit,
				validTo
		  )
		: translate(
				'number.services.jawazak.package.description',
				totalPackageSize.value,
				totalPackageSize.unit,
				validTo
		  );
};

export const goBizPackageDescription = (singlePackage: Package): string => {
	const validTo = moment(singlePackage.validTo).format('DD.MM.YYYY, HH:mm A');
	return translate('number.services.gobiz.packages.description', singlePackage.name, validTo);
};

export const internationalMinutesPackageDescription = (singlePackage: Package): string => {
	const validTo = moment(singlePackage.validTo).format('DD.MM.YYYY, HH:mm A');
	return translate('number.services.international.packages.description', singlePackage.name, validTo);
};
